











































































































































































import {
  getIntegralLogSourceApi,
  getIntegralLogListData,
  getIntegralLogListApi,
  exportIntegralLogData,
  exportIntegralLogApi,
} from "@/api/integral";
import { searchStudent } from "@/api/globalSearch";
import { exportLoop } from "@/utils/export";
import { dateFormat } from "@/utils/timeFormat";
import { Vue, Component } from "vue-property-decorator";
import commonDateRangeSelector from "@/components/commonDateRangeSelector.vue";

@Component({
  components: {
    commonDateRangeSelector,
  },
})
export default class extends Vue {
  searchInfo: any = {
    type: [],
    source: "",
  };
  sourceList: any[] = [];
  sourceObject = {};
  tableData: any[] = [];
  page: number = 1;
  pageSize: number = 10;
  pageSizeArray: number[] = [5, 10, 30, 50, 100];
  total: number = 0;
  typeObject = {
    1: "扣除",
    2: "增加",
    3: "冻结",
    4: "解冻",
  };
  effectiveDate: any = {
    disabledDate(date: any) {
      return date > Date.now();
    },
  };

  created() {
    getIntegralLogSourceApi().then((res) => {
      this.sourceList = res.data.list;
      const obj: any = {};
      res.data.list.map((item: any) => {
        obj[item.key] = item.value;
      });
      this.sourceObject = obj;
    });
    this.getList({
      page: 1,
      page_size: this.pageSize,
    });
  }
  handleSearch() {
    this.getList({
      page: 1,
      page_size: this.pageSize,
    });
  }
  getList(page: { page: number; page_size: number }) {
    const params: getIntegralLogListData = {
      page: page.page,
      page_size: page.page_size,
    };
    if (this.searchInfo.date) {
      params.start_date = this.searchInfo.date[0];
      params.end_date = this.searchInfo.date[1];
    }
    if (this.searchInfo.key_word) {
      params.key_word = this.searchInfo.key_word;
    }
    if (this.searchInfo.source && this.searchInfo.source >= 0) {
      params.source = this.searchInfo.source;
    }
    if (this.searchInfo.type.length > 0) {
      params.type = this.searchInfo.type;
    }
    getIntegralLogListApi(params).then((res) => {
      res.data.list.map((item: any) => {
        item.create_time = dateFormat(
          "YYYY-mm-dd HH:MM",
          new Date(item.create_time * 1000)
        );
      });
      this.tableData = res.data.list;
      this.page = res.data.page;
      this.total = res.data.total;
    });
  }
  handlePagerChange(e: number) {
    this.getList({
      page: e,
      page_size: this.pageSize,
    });
  }
  handlePagerSizeChange(e: number) {
    this.pageSize = e;
    this.getList({
      page: 1,
      page_size: e,
    });
  }
  handleExport() {
    const params: exportIntegralLogData = {};
    if (this.searchInfo.date) {
      params.start_date = this.searchInfo.date[0];
      params.end_date = this.searchInfo.date[1];
    }
    if (this.searchInfo.key_word) {
      params.key_word = this.searchInfo.key_word;
    }
    if (this.searchInfo.source >= 0) {
      params.source = this.searchInfo.source;
    }
    if (this.searchInfo.type.length > 0) {
      params.type = this.searchInfo.type;
    }
    exportIntegralLogApi(params).then((res: any) => {
      exportLoop(res.data.task_id);
    });
  }
}
